import { useContext } from 'react';
import { interfaces } from 'inversify';

import { InjectionContext } from './context';

export function useInjection<T>(identifier: interfaces.ServiceIdentifier<T>): T {
  const context = useContext(InjectionContext);
  return context?.container?.get(identifier);
}
